export default __webpack_public_path__ + "static/media/listt.1d9fa3bf.svg";